module.exports = __webpack_public_path__ + "img/hr-brown-fluff-dry-10.f6ff01a5.png";